import React from 'react';
import { Back } from '../../assets/svgs';
import { useNavigate } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';

const Match= () => {
  const navigate = useNavigate()
  return (
    <>
      <div
      className="flex justify-between flex-col wrapper bg-no-repeat bg-cover bg-bgPosition overflow-hidden"
      style={{ backgroundImage: `url('assets/images/bg-detail.png')` }}
      >
        <Header />
        <div className='main-section flex-grow-1 basis-0'>
          <div className="relative pt-3 md:pt-6 pb-4 md:pb-8 sm:pt-12 sm:pb-20">
            <div className='absolute -bottom-30 left-0 z-1'>
            <img
                  src="assets/images/left-mountain.png"
                  className="h-auto max-w-full"
                  alt="dragon" />
            </div>
            <div className=" block relative max-w-containerLarge m-auto px-4 sm:flex sm:justify-between z-50">
                <span className="block mb-2 xl:mb-4 lg:w-1/4 sm:w-1/6 " onClick={()=> navigate('/arena')}>
                  <span className="inline-flex flex-wrap items-center text-white cursor-pointer">
                    <span className="icon mr-3"><Back /></span> Back
                  </span>
                </span>
                <div className='sm:w-full text-center lg:pr-9 -ml-8 sm:-ml-6 pl-8'>
                  <div className='sm:mb-10 mb-2 m-auto'>
                    <div className='w-20 m-auto mb-2'>
                      <img
                        src="assets/images/slide-3.png"
                        className="h-auto max-w-full"
                        alt="dragon" /> 
                    </div>  
                  <div className='sm:w-2/3 m-auto'>
                    <h1 
                    className="block sm:font-extrabold text-fGray font-k2D text-2xl sm:text-4xl bg-clip-text text-transparent bg-gradient-to-r from-textForm to-textPeach mb-5">
                      MATCH4
                    </h1>
                    <p className='block text-white  mb-4 text-xs lg:text-base'>
                      Match4 is our modern take on the classic tic-tac-toe game, featuring a 6x6 grid with a twist – the ability to rotate the grid itself. This innovative addition adds a new layer of strategy and excitement to a beloved game, challenging players to think creatively and tactically to outsmart their opponents. Get ready for hours of entertainment as you experience Match4 in the Pixiuverse.
                    </p>
                  </div>
                  <div className='pt-10 sm:flex'>
                    <div className="w-full mr-4 mb-4 rounded-3xl bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 pr-2 pt-2 pl-2 pb-2">
                        <img
                        src="assets/images/dargongame-1.png"
                        className=" w-full rounded-3xl"
                        alt="dragon" />
                    </div>  
                    <div className="w-full rounded-3xl mb-4 bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 pr-2 pt-2 pl-2 pb-2">
                        <img
                        src="assets/images/dargongame-2.png"
                        className="h-auto w-full rounded-3xl"
                        alt="dragon" />
                    </div> 
                  </div>
                </div>
            </div>
          </div>
        </div>  
        <Footer />
        </div>
      </div>
    </>
    );
}

export default Match;
